import React from "react";

import { Flex, Icon, MenuList, Menu, MenuButton, MenuItem } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { BiGlobe } from "react-icons/bi";

import { useLanguageSelector } from "./hooks/useLanguageSelector";

const LanguageSelector = ({ hideLabel }) => {
  const { show, languages, setLanguage, locale } = useLanguageSelector();

  return show ? (
    <Menu
      autoSelect={false}
      rootProps={{
        width: "150px",
      }}
    >
      <MenuButton
        border="1px solid gray"
        minW={hideLabel ? "50px" : "110px"}
        borderRadius="5"
        p="1"
        data-testid="language-selector-button"
      >
        <Flex alignItems="center" justifyContent={hideLabel ? "center" : "space-between"}>
          <Icon as={BiGlobe} fill="integrator.500" />
          {hideLabel ? null : (
            <>
              {languages.find(({ value }) => locale === value).label}
              <ChevronDownIcon />
            </>
          )}
        </Flex>
      </MenuButton>
      <MenuList data-testid="language-selector-list" minWidth="150px">
        {languages.map(({ value, label }) => {
          const isSelected = value === locale;
          return (
            <MenuItem
              key={value}
              value={value}
              background={isSelected && "lightBackground"}
              _focus={
                {
                  // disable default focus styling
                }
              }
              onClick={(e) => {
                e.preventDefault();
                setLanguage(e.target.value);
              }}
            >
              {label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  ) : null;
};

export default LanguageSelector;
